import Modal from './../../scripts/modal';
import serialize from 'form-serialize'
import sort from 'array-sort'
import getAlertById from '../../scripts/get-alert-by-id'
import SiteMessagesInstance from '../../components/site-messages'
import modalApproveLinkedAccount from './modal-approve-linked-account'
import isAccountEnterprise from '../../scripts/is-account-enterprise'

class AccountUsers {

  constructor (container) {

    this.maximumSubUsers = 10;
    this.excludedMaxSubUsers = [137746] // users allowed to have more than 5

    if(container) {

      this.container = container;
      this.section = container.querySelector('.account-content-section[data-for="users"]');
      this.content = this.section.querySelector('.account-users');

      this.render();

      this.enterpriseContent = this.section.querySelector('.account-users-enterprise');
      this.enterpriseAccounts = null;

      this.subUsersEl = container.querySelector('.account-sub-users__users');
      this.masterUser = this.section.querySelector('.account-sub-users__master-user__user');

      this.masterUser.innerHTML = window.currentUser.is_sub_user ? window.currentUser.sub_user.parent.email : window.currentUser.email;

      this.createUserMessage = this.section.querySelector('.account-sub-users__create-user__message');
      this.createUserBtn = this.section.querySelector('button[name="create-sub-user"]');

      this.actions();

    }

  }

  render() {

    this.content.innerHTML = `
    <div class="account-sub-users">

        <p>
          Allow other people to view your account.
          <br />
          By default sub users cannot make changes without Admin permission enabled.
        </p>

        <h3 class="heading--smaller">Primary User</h3>
        <div class="account-sub-users__master-user">
          <div class="account-sub-users__master-user__user"></div>
        </div>

        <div class="account-sub-users__create-user">
          <button class="button button--teal" name="create-sub-user"><i class="far fa-plus"></i> Create Sub User</button>
          <div class="account-sub-users__create-user__message"></div>
        </div>

        <br />

        <p class="setting__description text--small">This table shows the sub users that have access to this account.</p>

        <div class="lite-list">
          <div class="lite-list__header">
            <div class="lite-list__header__col" data-for="delete"></div>
            <div class="lite-list__header__col" data-for="email">Email</div>
            <div class="lite-list__header__col" data-for="status">Status</div>
            <div class="lite-list__header__col" data-for="created">Date Added</div>
            <div class="lite-list__header__col" data-for="actions">Admin</div>
          </div>

          <div class="account-sub-users__users lite-list-contents">
            <div class="lite-list__row "></div>
            <div class="lite-list__row"></div>
          </div>

        </div>

      </div>
      <div class="account-users-enterprise"></div>
    `;

  }

  async init() {
    this.loadSubUsers();
    await this.maybeLoadLinkedEnterprise();
  }

  getEnterpriseAccount(account_id) {

    if(this.enterpriseAccounts) {

      for(let account of this.enterpriseAccounts) {
        if(account.user_id == account_id) {
          return account;
        }
      }

    }

    return null;

  }

  async maybeLoadLinkedEnterprise() {

    // Enterprise cannot manage links
    if(isAccountEnterprise()) {
      return;
    }

    const res = await window.apiRequest('get', '/user/linked-accounts');

    if(res.type === 'success' && res.data.length > 0) {

      let html = `
      <p class="text--bold">Enterprise Linked Accounts</p>
      <p>These accounts will have full administrative access to your account</p>
      <div class="lite-list">
          <div class="lite-list__header">
            <div class="lite-list__header__col" data-for="email">Enterprise User</div>
            <div class="lite-list__header__col" data-for="created">Date Added</div>
            <div class="lite-list__header__col" data-for="actions"></div>
          </div>
      `;

      let accounts = res.data;

      accounts = sort(accounts, 'created', {});

      this.enterpriseAccounts = accounts;

      for(let account of accounts) {
        html += `
         <div class="lite-list__row">
          <div class="lite-list__row__col" data-for="email">${account.email}</div>
          <div class="lite-list__row__col" data-for="created">${window.getUserTimezoneDate(account.created).format('MMM DD, YYYY h:mm a')}</div>
          <div class="lite-list__row__col" data-for="actions">
          
            ${account.status == 1 ? `<span class="inline-label inline-label--success">Active</span>` : `
              <button class="button button--small button--black" data-action="approve_linked_account" data-for="${account.user_id}" style="margin-right: 10px;">Approve</button>
            `}
            
          </div>
        </div>
        `
      }

      html += '</div>';

      this.enterpriseContent.innerHTML = html;

    }

  }

  actions() {

    $(this.section).on('click', 'button[data-action="approve_linked_account"]', e => {

      const accountId = $(e.currentTarget).data('for');

      const account = this.getEnterpriseAccount(accountId);

      if(account) {
        modalApproveLinkedAccount({
          account: account,
          onClose: this.maybeLoadLinkedEnterprise.bind(this),
        });
      }

    });

    this.createUserBtn.addEventListener('click', this.openCreateUserModal.bind(this));

    $(this.container).on('change', '.sub-user-read-only-checkbox', e => {

      const checkbox = $(e.currentTarget);
      const subUserId = checkbox.data('for');

      const row = checkbox.parent().parent().parent();
      row.addClass('loading-overlay');

      window.apiRequest('post', `/sub-users/read-only/${subUserId}`, {
        read_only: checkbox.is(':checked') ? '0' : '1', //0 for Admin, 1 for Read-Only, Label is opposite
      }).then(r => {

        row.removeClass('loading-overlay');
        console.log(r);

      })

    });

    $(this.container).on('click', '.account-sub-users__users__user__remove__button', e => {

      const btn = $(e.currentTarget);
      const subUserId = btn.data('for');

      this.openDeleteSubUserModal(subUserId);

    });

  }

  openDeleteSubUserModal(subUserId) {

    this.getSubUsers().then(() => {

      let subUser = null;

      this.subUsers.forEach(user => {

        if(user.id == subUserId) {
          subUser = user;
        }
      });

      if(!subUser) {
        alert('This sub user does not exist, refresh the page and try again');
        return;
      }

      const modal = new Modal({
        class: ['sub-user-modal', 'form-modal'],
        title: 'Delete Sub User',
      });

      modal.setContent(`
      
      <div class="grid-container">
      
      <p>Are you sure you wish to delete this sub user?</p>
      
      <div class="grid-x grid-margin-x form-modal__row">
        <div class="cell medium-2">Name</div>
        <div class="cell medium-8" style="font-weight: bold; font-size:1.2em;">
          ${subUser.email}
        </div>
      </div>
      
      <div class="divider"></div>
      
      <p class="text--small">This action cannot be undone.</p>
        
      <div class="form-modal-actions">
        <div class="form-modal-actions__submit">
          <button type="button" class="button" style="margin-right: 20px;" data-for="okay">Delete Sub User</button>&nbsp;
          <button type="button" class="button gray" data-for="cancel">Cancel</button>
        </div>
      </div>
      
      </div>
        
    `);

      const $modalContainer = $(modal.getContainer());

      $modalContainer.on('click', '.button[data-for="okay"]', () => {

        window.apiRequest('post', `/sub-users/delete/${subUserId}`).then(r => {

          if(r.type === 'success') {
            this.loadSubUsers();
            modal.close();
          } else {

            SiteMessagesInstance.addMessage('error', r.message);
            SiteMessagesInstance.displayMessages();
            modal.close();

          }

        });

      });

      $modalContainer.on('click', '.button[data-for="cancel"]', () => {
        modal.close();
      });

      modal.open();

    });

  }

  getSubUsers() {

    return new Promise((resolve, reject) => {

      window.apiRequest('get', '/sub-users').then(r => {

        if(r.type === 'success') {
          this.subUsers = r.data;
        }

        resolve();

      });

    });

  }

  loadSubUsers() {

    $(this.subUsersEl).addClass('loading-overlay');

    this.getSubUsers().then(() => {

      $(this.subUsersEl).removeClass('loading-overlay');

      if(this.subUsers.length > 0) {

        let subUsers = this.subUsers;
        let html = '';

        subUsers = sort(subUsers, 'email', {});

        subUsers.forEach(subUser => {

          html += `
          <div class="lite-list__row">
            <div class="lite-list__row__col" data-for="delete">
              <span class="lite-list__row-label">Remove sub user:</span>
              <button type="button" class="account-sub-users__users__user__remove__button" data-for="${subUser.id}">
                <i class="far fa-times" title="Remove sub user from account" aria-hidden="true"></i>
              </button>
            </div>
            <div class="lite-list__row__col" data-for="email">
              <span class="lite-list__row-label">Email:</span>
              ${subUser.email}
            </div>
            <div class="lite-list__row__col" data-for="status">
              <span class="lite-list__row-label">Status:</span>
              ${subUser.invitation_token ? 
                '<span class="inline-label inline-label--warning">Pending</span>' : 
                '<span class="inline-label inline-label--success">Active</span>'
              }
            </div>
            <div class="lite-list__row__col" data-for="created">
              <span class="lite-list__row-label">Date Added:</span>
              ${window.getUserTimezoneDate(subUser.invitation_sent).format('MMM D, YYYY')}
            </div>
            <div class="lite-list__row__col" data-for="actions">
            
              <span class="lite-list__row-label">Admin:</span>
              
              <div class="switch medium">
                <input class="switch-input sub-user-read-only-checkbox" 
                  type="checkbox" id="sub-user-${subUser.id}-read-only"
                  name="sub-user-${subUser.id}-read-only" 
                  data-for="${subUser.id}" 
                  value="1" ${subUser.sub_user.read_only == 0 ? 'checked' : ''} 
                />
                       
                <label class="switch-paddle" for="sub-user-${subUser.id}-read-only">
                  <span class="switch-active">Yes</span>
                  <span class="switch-inactive">No</span>
                </label>
              </div>
              
            </div>  
          </div>        
          `;
        });

        $(this.subUsersEl).html(html);

      } else {
        $(this.subUsersEl).html(`
          <div class="account-sub-users__users__message">
            Your account doesn't have any sub users.
          </div>
          `);
      }

    });

  }

  openCreateUserModal() {

    const modal = new Modal({
      class: ['create-sub-user-modal'],
      title: 'Create Sub User',
    });

    modal.setContent(`
    <form class="create-sub-user-form">
      <div class="setting">
        <div class="setting__label">Sub User Email</div>
        <input type="email" name="email" required>
        <div class="setting__description">An invitation to create a sub user account will be sent to this email</div>
      </div>

      <div class="setting-save">
        <div class="setting-save__button">
          <button type="submit" class="button button--blue">Invite New Sub User</button>
        </div>
        <div class="setting-save__message"></div>
      </div>
    </form>
    `);

    const form = modal.getContentContainer().querySelector('form');

    form.addEventListener('submit', e => {
      e.preventDefault();

      const container = modal.getContentContainer();

      const btn = container.querySelector('button[type="submit"]');
      btn.disabled = true;

      const saveMsg = container.querySelector('.setting-save__message');
      saveMsg.innerHTML = 'Processing...';

      modal.getContentContainer().classList.add('loading-overlay');

      const data = serialize(form, { hash: true });

      apiRequest('post', '/sub-users/create', data).then(r => {

        modal.getContentContainer().classList.remove('loading-overlay');

        if(r.type === 'error') {

          saveMsg.innerHTML = r.message;

          setTimeout(() => {
            btn.disabled = false;
          }, 2000);

        } else {

          saveMsg.innerHTML = `
            <div class="text--green">
              <i class="fas fa-check-circle"></i>
              We successfully sent out the sub user invitation
            </div>
          `;

          this.loadSubUsers();

        }

      });

    });

    modal.open();

  }

}

export default AccountUsers;
